export { WithAcademyLanguageWatcher as Route } from './components/WithAcademyLanguageWatcher';